import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { type Banner, type CreateBannerPayload } from '../types';
import { bannerApi } from '../api';
import { bannerKeys } from './banner.keys';

export function useCreateBanner(
  options?: UseMutationOptions<Banner, Error, CreateBannerPayload>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['banners', 'create'],
    mutationFn: bannerApi.create,
    ...mutationOptions,
    onSuccess: (banner, variables, onMutateResult, context) => {
      toast({ title: 'Banner criado com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: bannerKeys.all });
      providedOnSuccess?.(banner, variables, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao criar banner',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  return {
    createBanner: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
